import {
	AfterViewInit,
	Component,
	forwardRef,
	OnDestroy,
	ViewChild
} from '@angular/core';
import { NgForm, NgModelGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator } from '@angular/forms';
import { Subscription } from 'rxjs';

import { BaseControlValueAccessor } from 'rev-shared/util/BaseControlValueAccessor';
import { IVideoField } from 'rev-shared/metadata/Metadata.Contract';
import { parentControlContainerProvider } from 'rev-shared/util/directives/form/validation/validationUtil';

@Component({
	selector: 'edit-webcast-custom-fields',
	templateUrl: './EditWebcastCustomFields.Component.html',
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		useExisting: forwardRef(() => EditWebcastCustomFieldsComponent),
		multi: true
	}, {
		provide: NG_VALIDATORS,
		useExisting: forwardRef(() => EditWebcastCustomFieldsComponent),
		multi: true,
	}],
	standalone: false
})
export class EditWebcastCustomFieldsComponent extends BaseControlValueAccessor<IVideoField[]> implements AfterViewInit, OnDestroy, Validator {
	private subscription: Subscription;
	private validateFn: () => void;

	@ViewChild(NgForm, { static: true })
	public customFieldsForm: NgForm;

	public trackById(index: number, customField: IVideoField): string {
		return customField.id;
	}

	public ngAfterViewInit(): void {
		this.subscription = this.customFieldsForm.statusChanges.subscribe(() => this.validateFn?.());
	}

	public ngOnDestroy(): void {
		this.subscription?.unsubscribe();
	}

	public validate(): ValidationErrors {
		if(this.customFieldsForm?.invalid) {
			return { invalid: true };
		}
	}

	public registerOnValidatorChange(fn: () => void): void {
		this.validateFn = fn;
	}

	public onCustomFieldChanged(): void {
		this.updateModelValue(this.value);
		this.validateFn();
	}
}
